import React, { useCallback, useState ,useContext } from 'react';
import PropTypes from 'prop-types';
import handleRequest from '../utils/handleRequest';
import { SET_JWT, SET_USER_ROLES } from '../actions/types';
import { GlobalContext } from '../Store';
import {useSnackbar} from "notistack";
import CloseIcon from '@material-ui/icons/Close';


const AuthContext = React.createContext();

const AuthProvider = (props) => {
  const { store, dispatch } = useContext(GlobalContext);
  const { enqueueSnackbar } = useSnackbar();
  
 

  const errorNotification = (message) => enqueueSnackbar(message, {
    variant: 'error',
    anchorOrigin: { horizontal: 'center', vertical: 'top' }
  });
 
  const login = useCallback(
    async (data, callback) => {
      const res = await handleRequest({
        method: 'post',
        url: '/users/login',
        data: data,
      });
  
      if (res.status === 200) {
        dispatch({
          type: SET_USER_ROLES,
          payload: { roles: res.result.roles },
        });
        dispatch({ type: SET_JWT, payload: { jwt: res.jwt } });
      } else {
        //console.log("res.message?.message",res?.message);
        res?.message && errorNotification(res.message);
        throw {status: res?.status,message:res?.message};
    
      }
      callback();
    },
    [dispatch]
  );

  const fetchRoles = useCallback(async () => {
      const res = await handleRequest({
        method: 'get',
        url: '/users/roles/refresh'
      });

      if (res.status === 200) {
        dispatch({
          type: SET_USER_ROLES,
          payload: { roles: res.result.roles },
        });
      } else {
        console.log(res.message);
      }
    },
    [dispatch]
  );

  const logout = useCallback(async () => {
    await handleRequest({
      method: 'post',
      url: '/users/logout',
    });

    dispatch({
      type: SET_USER_ROLES,
      payload: { roles: [] },
    });
    dispatch({ type: SET_JWT, payload: { jwt: undefined } });
  }, [dispatch]);

  const state = {
    jwt: store.jwt,
    roles: store.roles || [],
  };

  const actions = {
    login,
    logout,
    fetchRoles
  };

  return (
    <AuthContext.Provider value={{ state, actions }}>
      {props.children}
    </AuthContext.Provider>
  );
};

AuthContext.propTypes = {
  children: PropTypes.element,
};

export { AuthProvider, AuthContext };
